export interface SonarTimeout {
	clearTimeout: () => void;
	context: () => void;
	delay: number;
	setTimeout: () => void;
	timeout: NodeJS.Timeout;
}

export class SonarGlobalTimeout implements SonarTimeout {
	context: () => void;

	delay: number;

	timeout: NodeJS.Timeout;

	constructor(delay: number, context: () => void) {
		this.delay = delay;
		this.context = context;
	}

	clearTimeout = (): void => {
		if (typeof this.timeout === 'number') {
			clearTimeout(this.timeout);
		}
	};

	setTimeout = (): void => {
		this.timeout = setTimeout(() => {
			this.context();
		}, this.delay);
	};
}
